export default __webpack_public_path__ + "static/media/menu_bar.26094246.svg";